import { connect } from 'react-redux';
import { RootState } from 'model/state';
import { Dispatch } from 'redux';
import { ConfirmationDialog } from 'components';
import { createStructuredSelector } from 'reselect';
import { selectIsOpenConfirmationDialog, selectConfirmationDialogMetadata } from 'selectors/Common';
import { closeConfirmationDialog } from 'actions/Common';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onHide: () => dispatch(closeConfirmationDialog()),
});

type SelectedValues = {
  show: boolean,
  confirmationDialogMetadata: { [key: string]: any },
}

const mapStateToProps = createStructuredSelector<RootState, SelectedValues>({
  show: selectIsOpenConfirmationDialog(),
  confirmationDialogMetadata: selectConfirmationDialogMetadata(),
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationDialog);